import React, {useContext, useEffect} from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { DataContext } from "../../components/Context";
import "./style.css";

const Footer = () => {

  const location = useLocation()

  return (
    <>
         {
          location.pathname === '/armatupc' ?
          null 
          :
          <footer>
          <div className="container grid2">
            <div className="box">
              <h1 className="h1-Lac">La Consola</h1>
              <p>Todos los derechos reservadosⓒ</p>
            </div>

            <div className="box">
              <h2>Nosotros</h2>
              <ul>
                <a
                  href="https://www.google.com/maps/place/La+Consola+Digital/@-32.9823539,-68.7923399,17z/data=!4m12!1m6!3m5!1s0x967e0cbe515a7533:0xe1b0585e6e8dbe2c!2sLa+Consola+Digital!8m2!3d-32.9823539!4d-68.7901512!3m4!1s0x967e0cbe515a7533:0xe1b0585e6e8dbe2c!8m2!3d-32.9823539!4d-68.7901512"
                  target="_blank"
                >
                  <li>Nuestra tienda📍</li>
                </a>

                <a href="/terminos">
                  <li>Términos y condiciones</li>
                </a>
              </ul>
            </div>
            <div className="box">
              <h2>Envíos</h2>
              <ul>
                <li>Envíos a todo el pais</li>
                <li>Nuestros productos poseen garantía</li>
                <li>
                  Retiros en nuestro local de<br></br>lunes a sábados de 9:30 a
                  13:00 y 16:30-20:00
                </li>
              </ul>
            </div>
            <div className="box">
              <h2>Contáctanos</h2>
              <ul>
                <li>📍Ozamis 298 - esquina 60, Granaderos. Maipú, Mendoza </li>

                <li>✉ laconsolamendoza@gmail.com</li>

                <a href="https://wa.me/542612565651">
                  <li> Teléfono: +54 261 2565651</li>
                </a>
              </ul>
            </div>
          </div>
        </footer>
         }
    </>
  );
};

export default Footer;
